import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

const useScrollState = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const { pathname } = useLocation();

  // useEffect(() => {
  //   if (pathname !== "/") {
  //     setIsScrolled(true);
  //     return;
  //   }

  // const handleScroll = () => {
  //   setIsScrolled(window.scrollY > 10);
  // };

  // handleScroll();
  // window.addEventListener("scroll", handleScroll);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, [pathname]);

  return isScrolled;
};

export default useScrollState;
